module.exports = __webpack_public_path__ + "img/CheckCode.50a07bd0.svg";